// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NetworkPage_networks__yIYIv::-webkit-scrollbar {
  display: none;
  width: 0;
}
.NetworkPage_networks__yIYIv .NetworkPage_networks-list__jh\\+yV {
  max-width: 777px;
  margin: auto;
}
@media screen and (min-width: 1600px) {
  .NetworkPage_networks__yIYIv .NetworkPage_networks-list__jh\\+yV {
    max-width: 1000px;
  }
}
.NetworkPage_networks__yIYIv .NetworkPage_createNetworkButton__g0XjE:focus {
  outline: 2px solid darkolivegreen;
  background-color: green;
}
.NetworkPage_networks__yIYIv .NetworkPage_createNetworkButton__g0XjE:focus::after {
  content: "Press Enter or Space to create new network";
  display: block;
  margin-top: 10px;
  font-size: 0.8em;
  color: white;
}

.NetworkPage_networkItem__ROarw {
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
  margin-left: 1rem;
  margin-right: 1rem;
  padding: 0.75rem;
  border-radius: 0.25rem;
  background: rgba(255, 255, 255, 0.8);
  box-shadow: 0px 3px 15px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}
.NetworkPage_networkItem__ROarw:hover {
  background: rgba(130, 255, 105, 0.9);
  opacity: 1;
  cursor: pointer;
  transform: scale(1.05) rotateX(20deg);
  box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.4);
}
.NetworkPage_networkItem__ROarw:hover::before {
  content: "";
  position: absolute;
  top: 5px;
  right: 5px;
  bottom: 5px;
  left: 5px;
  z-index: -1;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 0.25rem;
}
.NetworkPage_networkItem__ROarw:active {
  background: rgba(126, 227, 174, 0.9);
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  transform: scale(0.95) rotateX(0deg);
}
.NetworkPage_networkItem__ROarw:focus {
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);
}`, "",{"version":3,"sources":["webpack://./src/Pages/Networks/NetworkPage.module.scss"],"names":[],"mappings":"AACC;EACE,aAAA;EACA,QAAA;AAAH;AAEC;EACE,gBAAA;EACA,YAAA;AAAH;AAEG;EAJF;IAKC,iBAAA;EACA;AACF;AAIE;EACE,iCAAA;EACA,uBAAA;AAFJ;AAKI;EACE,qDAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AAHN;;AAUE;EACD,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,oCAAA;EACA,2CAAA;EACA,yBAAA;AAPD;AASC;EACE,oCAAA;EACA,UAAA;EACA,eAAA;EACA,qCAAA;EACA,2CAAA;AAPH;AAUG;EACD,WAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,8BAAA;EACA,sBAAA;AARF;AAYC;EACE,oCAAA;EACA,2CAAA;EACA,oCAAA;AAVH;AAaC;EACE,aAAA;EACA,+CAAA;AAXH","sourcesContent":[".networks {\n\t&::-webkit-scrollbar {\n\t  display: none;\n\t  width: 0;\n\t}\n\t.networks-list {\n\t  max-width: 777px;\n\t  margin: auto;\n  \n\t  @media screen and (min-width: 1600px) {\n\t\tmax-width: 1000px;\n\t  }\n\t}\n\n\t.createNetworkButton {\n\t\t// Custom styles for your button\n\t\t&:focus {\n\t\t\t\toutline: 2px solid darkolivegreen; // Highlighted focus\n\t\t\t\tbackground-color: green; // Change background color on focus\n\n\t\t\t\t// Pseudo-element for displaying instruction\n\t\t\t\t&::after {\n\t\t\t\t\t\tcontent: 'Press Enter or Space to create new network';\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\tmargin-top: 10px;\n\t\t\t\t\t\tfont-size: 0.8em;\n\t\t\t\t\t\tcolor: white;\n\t\t\t\t}\n\t\t}\n}\n\n  }\n  \n  .networkItem {\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-bottom: 0.5rem;\n\tmargin-left: 1rem;\n\tmargin-right: 1rem;\n\tpadding: 0.75rem;\n\tborder-radius: 0.25rem;\n\tbackground: rgba(255, 255, 255, 0.8);  // Green tone and transparent\n\tbox-shadow: 0px 3px 15px rgba(0,0,0,0.2);\n\ttransition: all 0.3s ease;\n  \n\t&:hover {\n\t  background: rgba(130, 255, 105, 0.9);\n\t  opacity: 1;\n\t  cursor: pointer;\n\t  transform: scale(1.05) rotateX(20deg);\n\t  box-shadow: 0px 8px 25px rgba(0,0,0,0.4);\n\t  \n\t  // pseudo-element for 3D effect on hover\n\t  &::before {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\ttop: 5px;\n\t\tright: 5px;\n\t\tbottom: 5px;\n\t\tleft: 5px;\n\t\tz-index: -1;\n\t\tbackground: rgba(0,0,0,0.2);\n\t\tborder-radius: 0.25rem;\n\t  }\n\t}\n  \n\t&:active {\n\t  background: rgba(126, 227, 174, 0.9);\n\t  box-shadow: 0px 2px 10px rgba(0,0,0,0.1);\n\t  transform: scale(0.95) rotateX(0deg);\n\t}\n  \n\t&:focus {\n\t  outline: none;\n\t  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);\n\t}\n  }\n\n\n\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"networks": `NetworkPage_networks__yIYIv`,
	"networks-list": `NetworkPage_networks-list__jh+yV`,
	"createNetworkButton": `NetworkPage_createNetworkButton__g0XjE`,
	"networkItem": `NetworkPage_networkItem__ROarw`
};
export default ___CSS_LOADER_EXPORT___;
